module.exports = __webpack_public_path__ + "static/media/Cam_01_Night.47b93f5b.jpg";